import { Box, Button, Typography } from "@mui/material";
import {
  LIBRARY_CREATE_BUTTON_TEXT,
  LIBRARY_EMPTY_STATE_TEXT,
} from "../constants/libraryConstants";

export default function LibraryEmptyState({ onCreatePlaylist }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        minHeight: "300px",
      }}
    >
      <Typography variant="h6" color="white">
        {LIBRARY_EMPTY_STATE_TEXT}
      </Typography>
      <Button variant="contained" onClick={onCreatePlaylist}>
        {LIBRARY_CREATE_BUTTON_TEXT}
      </Button>
    </Box>
  );
}
